import { PropType } from 'vue'

export type ArticleLinkParams = { [key: string]: string }

export const SEARCH_PROPS = {
  logSearchEvent: {
    type: Function as unknown as PropType<((query: string) => void) | null>,
    default: null,
  },
} as const
